import algolia from "../../common/assets/images/algolia.svg";

const FromAlgolia = () => {
    return <img className="algolia-logo" src={algolia} alt="Search by algolia" />
}

export default FromAlgolia;
